import axios from "axios";

const axiosInstance = axios.create({ baseURL: process.env.API_ENDPOINT, withCredentials: true });

// Add an interceptor to include the access token in the request headers
axiosInstance.interceptors.request.use(
  (config) => {
    // console.log("axios instance". config)
    // const accessToken = localStorage.getItem("accessToken");
    // if (accessToken) {
    //   config.headers["Authorization"] = `Bearer ${accessToken}`;
    // }
    // config.headers["Access-Control-Allow-Origin"] = `*`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isRefreshing = false;
let pendingRequests = [];

function onRefreshed() {
  pendingRequests.forEach((cb) => cb());
  pendingRequests = [];
}

function addPendingRequest(cb) {
  pendingRequests.push(cb);
}

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes("/check-cookies")) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve) => {
          addPendingRequest(() => resolve(axiosInstance(originalRequest)));
        });
      }

      isRefreshing = true;

      try {
        await axiosInstance.post("/api/check-cookies");
        onRefreshed();
        return axiosInstance(originalRequest);
      } catch (refreshErr) {
        pendingRequests = [];
        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
